export default class UnfollowUser {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  /**
   * Se désabonner d'un utilisateur
   * @param {string} currentUserId - ID de l'utilisateur qui se désabonne
   * @param {string} targetUserId - ID de l'utilisateur à ne plus suivre
   * @returns {Promise<boolean>} - Résultat de l'opération
   */
  async execute(currentUserId, targetUserId) {
    try {
      console.log(`UnfollowUser UseCase - ${currentUserId} ne suit plus ${targetUserId}`);
      
      if (!currentUserId || !targetUserId) {
        throw new Error('IDs utilisateur non valides');
      }

      // Utiliser la méthode existante du repository
      await this.userRepository.unfollowUser(currentUserId, targetUserId);
      console.log(`${currentUserId} ne suit plus ${targetUserId}`);
      return true;
    } catch (error) {
      console.error('Erreur dans UnfollowUser UseCase:', error);
      throw error;
    }
  }
} 